import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/merchant',
  component: Layout,
  redirect: '/merchant',
  name: 'merchant',
  meta: {
    title: '商家',
    icon: 'shop',
  },
  children: [
    {
        path: 'shop',
        name: 'shopIndex',
        component: () => import('@/views/merchant/shop.vue'),
        meta: {
            title: '店铺管理',
            breadcrumb: true,
            auth: [
                'Merchant.Shop.menu'
            ]
        }
    },
    // {
    //     path: 'product',
    //     name: 'productIndex',
    //     component: () => import('@/views/merchant/product.vue'),
    //     meta: {
    //         title: '产品管理',
    //         breadcrumb: true,
    //         auth: [
    //             'Merchant.Product.menu'
    //         ]
    //     }
    // },
  ],
}

export default routes
